<template>
  <section id="weltweit">
    <div class="container text-center">
      <div class="row align-items-center">
        <div class="col-12">
          <h2 class="productheadlineh2 mapHeadline wow fadeInDown">
            {{ $t("map_header") }}
          </h2>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-12">
          <p
            class="fontp mapRecommendation"
            v-html="$t('map_recommendations')"
          ></p>
        </div>
      </div>

      <div class="wow fadeInUpBig d-block d-sm-none" data-wow-duration="800ms">
        <img src="@/assets/images/map_blank.jpg" />
        <div class="col-12">
          <p
            class="fontbold"
            v-for="country in countries"
            :key="country.countryName"
          >
            {{ $t(country.countryName) }}<br />
            <span class="fontp">{{ $t(country.countryRecommendations) }}</span>
          </p>
        </div>
      </div>
    </div>
    <div
      id="image-map-pro-containerMap"
      class="wow fadeInUpBig d-none d-sm-block text-right"
      data-wow-duration="800ms"
    ></div>
  </section>
</template>

<script>
import { loadWorldMap } from "@/services/scripts/worldMap";
export default {
  name: "WorldwideSection",
  data() {
    return {
      countries: [
        {
          countryName: "map_germany",
          countryRecommendations: "map_germany_recommendations"
        },
        {
          countryName: "map_france",
          countryRecommendations: "map_france_recommendations"
        },
        {
          countryName: "map_denmark",
          countryRecommendations: "map_denmark_recommendations"
        },
        {
          countryName: "map_canada",
          countryRecommendations: "map_canada_recommendations"
        },
        {
          countryName: "map_usa",
          countryRecommendations: "map_usa_recommendations"
        },
        {
          countryName: "map_australia",
          countryRecommendations: "map_australia_recommendations"
        },
        {
          countryName: "map_uk",
          countryRecommendations: "map_uk_recommendations"
        }
      ]
    };
  },
  mounted() {
    loadWorldMap(this.$i18n);
  },
  watch: {
    "$i18n.locale"() {
      loadWorldMap(this.$i18n);
    }
  }
};
</script>

<style scoped>
#weltweit {
  background: white;
}

.mapHeadline {
  margin-top: 60px;
  color: black;
  margin-bottom: 50px;
  letter-spacing: 3px;
  visibility: visible;
}

.mapRecommendation {
  color: black;
  margin-bottom: 50px;
}
</style>
